import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.language,
    props.app.sounds,
    (language, sounds) => {
        return {
            language,
            sounds
        }
    }
)